import { ElMessageBox } from "element-plus";

export default{
    caracteresRestantes(value, max) {
        if (!value) return max;
        return max - value.length;
    },
    compararFechas(a, b) {
        const fechaA = new Date(a.fecha_Nac);
        const fechaB = new Date(b.fecha_Nac);
    
        // Comparar por mes
        if (fechaA.getMonth() < fechaB.getMonth()) return -1;
        if (fechaA.getMonth() > fechaB.getMonth()) return 1;
    
        // Si los meses son iguales, comparar por día
        if (fechaA.getDate() < fechaB.getDate()) return -1;
        if (fechaA.getDate() > fechaB.getDate()) return 1;
    
        return 0; // Las fechas son iguales
    },
    ordenarInicioContrato(a, b) {
        // Parsear las fechas antes de compararlas
        const fechaA = new Date(a.fecha_Inicio);
        const fechaB = new Date(b.fecha_Inicio);
        
        // Comparar las fechas
        if (fechaA < fechaB) {
            return -1;
        } else if (fechaA > fechaB) {
            return 1;
        } else {
            return 0;
        }
    },
    async confirmCambioTurno(){
        let res = false;
        await ElMessageBox.confirm(
            "¿Está seguro de que desea hacer cambio de turno?",
            "Reservar Habitaciones",
            {
                confirmButtonText: "Reservar",
                cancelButtonText: "Cancelar",
                type: "info",
                draggable: true,
                center: true,
                showClose: false,
                confirmButtonClass: "actualizarConfirm",
                cancelButtonClass: "cancelarConfirm",
                roundButton: true,
                lockScroll: false,
                customClass: "MessagetextClass",
                appendTo: document.body
            }
        )
        .then(() => {
            res = true;
        })
        .catch(() => {
            res = false;
        });
    
        return res;
    },
    async confirmUpdatePrices() {
        let res = false;
        await ElMessageBox.confirm(
            "¿Está seguro de que desea actualizar los precios de los platos?",
            "Actualizar Precios",
            {
                confirmButtonText: "Actualizar",
                cancelButtonText: "Cancelar",
                type: "info",
                draggable: true,
                center: true,
                showClose: false,
                confirmButtonClass: "actualizarConfirm",
                cancelButtonClass: "cancelarConfirm",
                roundButton: true,
                lockScroll: false,
                customClass: "MessagetextClass",
                appendTo: document.body
            }
        )
        .then(() => {
            res = true;
        })
        .catch(() => {
            res = false;
        });
    
        return res;
    },
    async confirmDel(type, context, secondaryText) {
        let res = false;
        await ElMessageBox.confirm(
          `¿Está seguro de eliminar ${type}? ${secondaryText ? secondaryText : ""}`,
          "Advertencia",
          {
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            type: "warning",
            draggable: true,
            center: true,
            showClose: false,
            confirmButtonClass: "eliminarConfirm",
            cancelButtonClass: "cancelarConfirm",
            roundButton: true,
            lockScroll: false,
            customClass: "MessagetextClass",
            appendTo: context ? context : document.body
          }
        )
          .then(() => {
            res = true;
          })
          .catch(() => {
            res = false;
          });
    
        return res;
    },
    verificar_registro(registro){
      if(registro.client != null && (registro.total != 0 && !isNaN(registro.total))){
          if(registro.buzo_termico==null || registro.buzo_termico.length == 0){
              registro.buzo_termico=0;
          }else{
              registro.buzo_termico=parseInt(registro.buzo_termico);
          }       
          if(registro.buzo_piloto==null || registro.buzo_piloto.length == 0){
              registro.buzo_piloto=0;
          }else{
              registro.buzo_piloto=parseInt(registro.buzo_piloto);
          }         
          if(registro.geologo==null || registro.geologo.length == 0){
              registro.geologo=0;
          }else{
              registro.geologo=parseInt(registro.geologo);
          }
          if(registro.chaqueta_operacional==null || registro.chaqueta_operacional.length == 0){
              registro.chaqueta_operacional=0;
          }else{
              registro.chaqueta_operacional=parseInt(registro.chaqueta_operacional);
          }
          if(registro.chaqueta_termica==null || registro.chaqueta_termica.length == 0){
              registro.chaqueta_termica=0;
          }else{
              registro.chaqueta_termica=parseInt(registro.chaqueta_termica);
          }
          if(registro.cortaviento==null || registro.cortaviento.length == 0){
              registro.cortaviento=0;
          }else{
              registro.cortaviento=parseInt(registro.cortaviento);
          }
          if(registro.buzo==null || registro.buzo.length == 0){
              registro.buzo=0;
          }else{
              registro.buzo=parseInt(registro.buzo);
          }
          if(registro.pantalon_polar==null || registro.pantalon_polar.length == 0){
              registro.pantalon_polar=0;
          }else{
              registro.pantalon_polar=parseInt(registro.pantalon_polar);
          } 
          if(registro.jeans==null || registro.jeans.length == 0){
              registro.jeans=0;
          }else{
              registro.jeans=parseInt(registro.jeans);
          } 
          if(registro.slack==null || registro.slack.length == 0){
              registro.slack=0;
          }else{
              registro.slack=parseInt(registro.slack);
          } 
          if(registro.camisa==null || registro.camisa.length == 0){
              registro.camisa=0;
          }else{
              registro.camisa=parseInt(registro.camisa);
          } 
          if(registro.pique==null || registro.pique.length == 0){
              registro.pique=0;
          }else{
              registro.pique=parseInt(registro.pique);
          } 
          if(registro.poleron_polar==null || registro.poleron_polar.length == 0){
              registro.poleron_polar=0;
          }else{
              registro.poleron_polar = parseInt(registro.poleron_polar);
          } 
          if(registro.polera_algodon==null || registro.polera_algodon.length == 0){
              registro.polera_algodon=0;
          }else{
              registro.polera_algodon=parseInt(registro.polera_algodon);
          }
          if(registro.primera_capa_polera==null || registro.primera_capa_polera.length == 0){
              registro.primera_capa_polera=0;
          }else{
              registro.primera_capa_polera=parseInt(registro.primera_capa_polera);
          }
          if(registro.primera_capa_pantalon==null || registro.primera_capa_pantalon.length == 0){
              registro.primera_capa_pantalon=0;
          }else{
              registro.primera_capa_pantalon=parseInt(registro.primera_capa_pantalon);
          } 
          if(registro.pijama==null || registro.pijama.length == 0){
              registro.pijama=0;
          }else{
              registro.pijama=parseInt(registro.pijama);
          } 
          if(registro.toalla==null || registro.toalla.length == 0){
              registro.toalla=0;
          }else{
              registro.toalla=parseInt(registro.toalla);
          } 
          if(registro.calza==null || registro.calza.length == 0){
              registro.calza=0;
          }else{
              registro.calza=parseInt(registro.calza);
          } 
          if(registro.calcetas==null || registro.calcetas.length == 0){
              registro.calcetas=0;
          }else{
              registro.calcetas= parseInt(registro.calcetas);
          } 
          if(registro.capuchon==null || registro.capuchon.length == 0){
              registro.capuchon=0;
          }else{
              registro.capuchon=parseInt(registro.capuchon);
          }
          if(registro.guantes==null || registro.guantes.length == 0){
              registro.guantes=0;
          }else{
              registro.guantes = parseInt(registro.guantes);
          } 
          if(registro.bolso==null || registro.bolso.length == 0){
              registro.bolso=0;
          }else{
              registro.bolso=parseInt(registro.bolso);
          }
          return true;
      }else{
          return false;
      }     
  },
}